module.exports = __webpack_public_path__ + "media/tima-miroshnichenko.18a95bb9.mp4";